/**
 * Facet Utilities
 * Facet merging and manipulation
 */

/**
 * Merge facet keys to preserve initial facets while updating counts
 * Keep all known keys (from initial facets), but use current counts
 * @param {Object} allFacetValues - Full facet values from search without current filter
 * @param {Object} currentFacetCounts - Current facet counts from filtered search
 * @returns {Object} - Merged facets
 */
export function mergeFacetKeys(allFacetValues, currentFacetCounts) {
  const all = allFacetValues || {};
  const cur = currentFacetCounts || {};
  const merged = {};
  // keep all known keys (from initial facets), but use current counts
  Object.keys(all).forEach((k) => {
    merged[k] = typeof cur[k] === 'number' ? cur[k] : 0;
  });
  // include any keys that appear only in current facets
  Object.keys(cur).forEach((k) => {
    if (typeof merged[k] === 'undefined') {
      merged[k] = cur[k];
    }
  });
  return merged;
}

console.log('📦 Facet utils module loaded');
